import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import StackedSection from '../StackedSection/StackedSection';

const BathAndBodySection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$bath&Body' });
  const { t: tLink } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$bath&Body' });

  return (
    <StackedSection
      title={t('title')}
      text={t('text')}
      btnText={t('btn')}
      img="/images/homePage/westin-white-tea-amenities-feel-well.webp"
      icon="icon-feel-well"
      link={tLink('bath&Body')}
    />
  );
};

export default BathAndBodySection;
